export const STALE_TIME = 5 * 60000;